<template>
  <v-app id="cidadaos-duplicados" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Procedimento"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="index"
          class="elevation-1"
          ref="tableBpc"
        >
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ calculatePageSum() }} de
              {{ calculateTotalSum() }} procedimentos</span
            >
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      enabled: null,
      search: '',
      headers: [
        {
          text: 'FOLHA',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'folha',
        },
        {
          text: 'SEQUÊNCIA',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'sequencia',
        },
        {
          text: 'PROCEDIMENTO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'procedimento',
        },
        {
          text: 'CBO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cbo',
        },
        {
          text: 'IDADE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'idade',
        },
        {
          text: 'QUANTIDADE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'quantidade',
        },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        let seq_global = Number(item.seq_global) || 0
        let sequencia = ((seq_global - 1) % 20) + 1
        let folha = Math.floor((seq_global - 1) / 20) + 1
        return {
          ...item,
          index: index,
          sequencia: sequencia,
          folha: folha,
        }
      })
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },
    getPagination(options) {
      this.currentPage = options.page
    },
    calculatePageSum() {
      const startIndex = (this.currentPage - 1) * 10
      const endIndex = startIndex + 10
      let pageItems = []
      if (this.search != '') {
        pageItems = this.$refs.tableBpc?.$children[0]?.filteredItems.slice(
          startIndex,
          endIndex
        )
      } else {
        pageItems = this.indexedItems.slice(startIndex, endIndex)
      }
      return pageItems.reduce((sum, item) => sum + parseInt(item.quantidade), 0)
    },
    calculateTotalSum() {
      if (this.search != '') {
        return this.$refs.tableBpc?.$children[0]?.filteredItems.reduce(
          (sum, item) => sum + parseInt(item.quantidade),
          0
        )
      } else {
        return this.indexedItems.reduce(
          (sum, item) => sum + parseInt(item.quantidade),
          0
        )
      }
    },
  },
}
</script>

<style lang="scss"></style>
